import React, { Fragment, useState, useContext } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Input,
  Label,
  Button,
  Form,
} from "reactstrap";
import { JobSearchContext } from "../../../../JobSearch/JobSearchContext";
import { CandidateSearchContext } from "../../../../CandidateSearch/CandidateSearchContext";
const EmploymentType = () => {
  const [isFilter, setIsFilter] = useState(false);
  const { filters, updateFilters } = useContext(CandidateSearchContext);
  const [searchKeyword, setSearchKeyword] = useState("");

  // console.log(checkedOptions);
  // Dynamic employment type options
  const employmentTypeOptions = [
    { value: "Permanent", label: "Permanent" },
    { value: "Temporary/Contractual Job", label: "Temporary/Contractual Job" },
    { value: "Freelance/Home Based", label: "Freelance/Home Based" },
    { value: "Apprenticeship", label: "Apprenticeship" },
  ];

  // Handle search input change
  const handleSearchChange = (e) => {
    const keyword = e.target.value;
    setSearchKeyword(keyword);
  };

  // Handle checkbox change
  const handleCheckboxChange = (option) => {
    // Toggle the checked state for the selected employment type
    const updatedOptions = filters.employment_type.includes(option.value)
      ? filters.employment_type((item) => item !== option.value)
      : [...filters.employment_type, option.value];

    updateFilters({ employment_type: updatedOptions });
  };

  return (
    <Fragment>
      <Col xl="12">
        <Card>
          <CardHeader className="py-3" onClick={() => setIsFilter(!isFilter)}>
            <h5 className="mb-0 p-0">Employment Type</h5>
          </CardHeader>
          <Collapse isOpen={isFilter}>
            <CardBody className="filter-cards-view animate-chk border-0">
              {/* <Form className="theme-form">

              <div className="job-filter mb-3">
                <div className="faq-form">
                  <Input
                    className="form-control form-control-sm"
                    type="text"
                    placeholder="Search employment type..."
                    onChange={handleSearchChange}
                  />
                  
                </div>
              </div>
              </Form> */}
              {/* <div className="checkbox-animated"> */}
              {employmentTypeOptions.map((option, index) => (
                <label
                  key={index}
                  className="d-flex"
                  htmlFor={`chk-emp-${index}`}
                >
                  <Input
                    className="checkbox_animated mr-2"
                    id={`chk-emp-${index}`}
                    type="checkbox"
                    checked={filters.employment_type.includes(option.value)}
                    onChange={() => handleCheckboxChange(option)}
                  />
                  {option.label}
                </label>
              ))}
              {/* </div> */}
              {/* <Button className="btn text-center" color="primary" type="button">
                Find jobs
              </Button> */}
            </CardBody>
          </Collapse>
        </Card>
      </Col>
    </Fragment>
  );
};

export default EmploymentType;
